import { ActionType, } from 'typesafe-actions';

import * as actions from './actions';

export const FETCH_INFO_REQUEST = 'FETCH_INFO_REQUEST';
export const FETCH_INFO_SUCCEEDED = 'FETCH_INFO_SUCCEEDED';
export const FETCH_INFO_FAILED = 'FETCH_INFO_FAILED';
export type InfoAction = ActionType<typeof actions>;
